import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeTimecardHistoryReport extends Layout {
    checkboxIncludeSettlementHistory: Checkbox;
    excludabletextboxDivisions: ExcludableTextbox;
    excludabletextboxJobClasses: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    excludabletextboxTerminals: ExcludableTextbox;
    sourceOfficeTimecardHistory: DataSource;
    switchReportType: Switch;
    textboxCheckDateRange: Textbox;
    textboxSort: Textbox;
}
